


















































































































































































































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { FontFamily } from "../../types";

const Customization = namespace("customization");
@Component({})
export default class CaptureDriversLicenseBack extends Vue {
  @Customization.Getter("getAccentColor") accentColor: string;
  @Customization.Getter("getSecondaryColor") secondaryColor: string;
  @Customization.Getter("getFontFamily") fontFamily: FontFamily;
}
